export default __webpack_public_path__ + "static/media/demo-event.3405a992.jpg";